import React from "react";
import BuillionAccountCompany from "./buillionAccountCompany/buillionAccountCompany";
import Header from "../../components/header/header";
import DashboardCarousel from "./dashboardCarousel";
import { DemoSlider } from "./advisorComponents/AdvisorSlider";

export default function home() {
  return (
    <>
      <Header title="Home" load={true} />
      <div className="container-fluid pt-4 pb-0 container-top landingPage">
        <div className="row">
          <div className="col-12 col-md-12">
            <DemoSlider />
          </div>
          <div className="col-lg-12 col-xl-12 col-md-12 mb-md-0 mb-0">
            <BuillionAccountCompany />
          </div>
        </div>
      </div>
    </>
  );
}
